import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=f0948762&scoped=true&"
import script from "./SectionTitle.vue?vue&type=script&lang=ts&"
export * from "./SectionTitle.vue?vue&type=script&lang=ts&"
import style0 from "./SectionTitle.vue?vue&type=style&index=0&id=f0948762&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0948762",
  null
  
)

export default component.exports